var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SuperInterceptor } from '../super-interceptor.service';
import { CurrencyService } from '../currency.service';
import { HeaderService } from '../header.service';
import { Cookie } from '../cookie.service';
/*import { HrefLang } from '../shared/angular2-hreflang';*/
///  <reference path="../../../../node_modules/@types/jquery/index.d.ts"/>
var RootInterceptor = /** @class */ (function (_super) {
    __extends(RootInterceptor, _super);
    function RootInterceptor(router, translate, cookie, currencyService, headerService, platformId /*, private hlang:HrefLang*/) {
        var _this = _super.call(this, router, cookie) || this;
        _this.router = router;
        _this.translate = translate;
        _this.cookie = cookie;
        _this.currencyService = currencyService;
        _this.headerService = headerService;
        _this.platformId = platformId;
        return _this;
    }
    ;
    RootInterceptor.prototype.canActivate = function (prev, next) {
        _super.prototype.canActivate.call(this, prev, next);
        var lang = this.cookie.get()['language'];
        if (!this.checkValidLanguage(lang)) {
            lang = this.checkValidLanguage(this.translate.getBrowserLang()) ? this.translate.getBrowserLang() : 'en';
        }
        this.translate.use(lang);
        this.router.navigate(["/" + lang + "/home"]);
        return false;
    };
    RootInterceptor.prototype.checkValidLanguage = function (lang) {
        if (lang == 'es' || lang == 'en' || lang == 'fr' || lang == 'it' || lang == 'de') {
            return true;
        }
        else {
            return false;
        }
    };
    return RootInterceptor;
}(SuperInterceptor));
export { RootInterceptor };
